import { render } from "./DeleteUser.vue?vue&type=template&id=7720872a&scoped=true"
import script from "./DeleteUser.vue?vue&type=script&lang=js"
export * from "./DeleteUser.vue?vue&type=script&lang=js"

import "./DeleteUser.vue?vue&type=style&index=0&id=7720872a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7720872a"

export default script